import { Capacitor } from '@capacitor/core';
import { LocalNotifications } from '@capacitor/local-notifications';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';
import { requestAndRegisterNativePush } from '@/lib/pushNotifications';

export function isNativeApp() {
  return Capacitor.isNativePlatform();
}

export function registerAppServiceWorker() {
  if (isNativeApp() || !('serviceWorker' in navigator)) return;

  window.addEventListener(
    'load',
    () => {
      void navigator.serviceWorker.register('/sw.js').catch(() => {});
    },
    { once: true },
  );
}

export async function initializeCapacitorRuntime() {
  if (!isNativeApp()) return;

  try {
    await StatusBar.setStyle({ style: Style.Dark });
    await StatusBar.setBackgroundColor({ color: '#F5EFE4' });
    await StatusBar.setOverlaysWebView({ overlay: true });
  } catch {}

  try {
    await SplashScreen.hide();
  } catch {}
}

export async function requestStartupNotifications(onToken?: (token: string) => void) {
  if (isNativeApp()) {
    try {
      await LocalNotifications.requestPermissions();
    } catch {}

    try {
      await requestAndRegisterNativePush(onToken);
    } catch {}
    return;
  }

  if (typeof Notification === 'undefined' || Notification.permission !== 'default') return;

  try {
    await Notification.requestPermission();
  } catch {}
}